/**
 * Constants for wizard components
 */

import { ROW_HEIGHT } from '@/components/table/constants';

/**
 * Row height constant for virtualization - uses table constant for consistency
 */
export const LIST_ITEM_HEIGHT = ROW_HEIGHT; // 48px - matches table rows
